import { status } from "skin/event/status";

let prMod = "0";

const cli = (obj, ms, story, data, d, action, code) => {
	const free = data.s.msSelectModCli.values.fld.free;
	const txtMod = data.s.msSelectModCli.values.fld.txtMod;

	if (obj.action === "setInput" && obj.name === "pr") {
		prMod = obj.value;
		data.setValue("pr", `${free ? "0" : obj.value}`);
	}

	// if (code === "msSelectModCli" && obj.name === "free") {
	if (obj.name === "free") {
		if (!txtMod) prMod = "0";
		data.setValue("pr", `${obj.value ? "0" : prMod}`);
	}
	return status.action;
};

export default cli;
